import classNames from 'classnames';
import { ButtonElement } from 'framework/button/elements';
import { useButtonTheme } from 'framework/button/hooks/useButtonTheme';
import { ButtonProps } from 'framework/button/types';
import { Icon } from 'framework/Icon';

import { EMPTY_FUNCTION } from '../../constants';

import cn from './Button.module.scss';

export const Button = ({
  children,
  onClick = EMPTY_FUNCTION,
  onFocus = EMPTY_FUNCTION,
  onBlur = EMPTY_FUNCTION,
  type = 'button',
  variant = 'normal',
  margin = '0px',
  height = '32px',
  width = 'fit-content',
  theme,
  left_icon,
  right_icon,
  shadow = false,
  disabled = false,
}: ButtonProps) => {
  const button_theme = useButtonTheme(variant, theme);

  return (
    <ButtonElement
      className={classNames(cn.button, 'transition', { [cn.shadow]: shadow })}
      onFocus={onFocus}
      onBlur={onBlur}
      onClick={onClick}
      type={type}
      height={height}
      data-disabled={disabled}
      theme={button_theme}
      style={{ minWidth: button_theme.general.min_width, width, margin }}
    >
      <Icon icon={left_icon} width="fit-content" disabled={disabled} button />
      {children}
      <Icon icon={right_icon} width="fit-content" disabled={disabled} button />
    </ButtonElement>
  );
};
